import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { Contact } from 'src/app/classes/models';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { CompanyService } from 'src/app/services/company.service';
import { ContactService } from 'src/app/services/contact.service';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-admin-client-contacts',
  templateUrl: './admin-client-contacts.component.html',
  styleUrls: ['./admin-client-contacts.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AdminClientContactsComponent {
  constructor(
    private CompanyService: CompanyService,
    private ContactService: ContactService,
    private SharedDataService: SharedDataService,
    private ModalService: NgbModal,
    private ToastService: ToastService
  ) {
    this.SharedDataService.listenForEvent<number>().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'SetCompanyId' && typeof data === 'number') {
          this.CompanyId = data;

          this.CompanyService.getCompany(this.CompanyId, {
            attributes: JSON.stringify(['id', 'legalName']),
            Contact: JSON.stringify({
              ExemptVendorId: null,
              ClientRegisteredVendorId: null,
              SiteId: null,
              ContractId: null
            })
          }).subscribe({
            next: (Company) => {
              const { legalName, Contacts } = Company;

              this.SharedDataService.sendEvent(
                'SetTitle',
                `Contacts - ${legalName}`
              );

              if (Array.isArray(Contacts)) {
                this.Contacts.push(...Contacts);
              }
            }
          });
        }
      }
    });

    this.SharedDataService.sendEvent('GetCompanyId');
  }

  CompanyId?: number;
  Contacts: Contact[] = [];

  deleteContact(Contact: Contact, index: number) {
    const { id: ContactId } = Contact;

    if (!ContactId) {
      throw this.ToastService.addErrorToast('Error', 'Contact is missing id.', {
        returnError: true
      });
    }

    const { componentInstance, result } = this.ModalService.open(
      ConfirmModalComponent,
      { backdrop: 'static', size: 'md' }
    );

    Object.assign(componentInstance, {
      displayText:
        'Deleting this contact will also delete the associated user. Do you want to continue?'
    });

    from(result).subscribe({
      next: (response) => {
        if (response) {
          this.ContactService.deleteContact(ContactId).subscribe({
            next: () => {
              this.Contacts.splice(index, 1);
              this.ToastService.addSuccessToast(
                'Success',
                'Successfully deleted contact.'
              );
            }
          });
        }
      }
    });
  }
}
